export default {
  "slug": "fire-alarm-wiring-and-circuits",
  "title": "Fire Alarm Wiring & Circuits, Simplified",
  "description": "Understand fire alarm circuits — IDC, NAC, and SLC — plus circuit class, pathway survivability, and how voltage drop affects notification appliances.",
  "keywords": "fire alarm wiring, NAC, SLC, fire alarm circuits, voltage drop, fire alarm technician",
  "ogImage": "/guide-og/fire-alarm-wiring-and-circuits.jpg",
  "faqs": [
    {
      "q": "What are IDC, NAC, and SLC circuits?",
      "a": "Initiating Device Circuits (IDC) gather inputs, Notification Appliance Circuits (NAC) power outputs like horns and strobes, and Signaling Line Circuits (SLC) carry addressable communication between the panel and devices."
    },
    {
      "q": "What is voltage drop and why does it matter?",
      "a": "Voltage drop is the loss of voltage along long wire runs with many appliances. Too much drop can starve strobes and horns, so conductor size, circuit loading, and supervision must be planned so every appliance receives adequate voltage."
    },
    {
      "q": "What do circuit class and pathway survivability mean?",
      "a": "Circuit 'class' describes how a circuit performs when a fault is present, while pathway survivability describes the ability to keep operating under fire conditions where required."
    }
  ],
  "category": "Systems",
  "readMins": 5,
  "published": "2026-08-17",
  "updated": "2026-09-27",
  "hero": "https://static.prod-images.emergentagent.com/jobs/73bed830-7de9-440e-a664-81f833da5bb8/images/e7464d8adbf9625cf11543f8b4c6ec5751fdf24397639aed0a57f4fd880f1558.jpeg",
  "heroAlt": "Illustration of a fire alarm wiring and circuit diagram",
  "excerpt": "Circuit type, class, and pathway integrity decide whether a system keeps working when a wire is damaged. Here's the plain-language version.",
  "sections": [
    {
      "h": "The circuit types",
      "p": "Initiating Device Circuits (IDC) gather inputs, Notification Appliance Circuits (NAC) power outputs, and Signaling Line Circuits (SLC) carry addressable communication. Putting devices on the wrong circuit is a common error."
    },
    {
      "h": "Class and survivability",
      "p": "Circuit 'class' describes how a circuit performs with a fault present, while pathway survivability describes the ability to keep operating under fire conditions where required."
    },
    {
      "h": "Voltage drop",
      "p": "Long runs with many appliances cause voltage drop that can starve strobes and horns. Conductor size, circuit loading, and supervision must be planned so every appliance receives adequate voltage."
    }
  ],
  "relatedModules": [
    "wiring-circuitry",
    "circuits",
    "supervision"
  ],
  "relatedGuides": [
    "fire-alarm-system-design-basics"
  ]
};
